"use client";

import { useEffect, useState } from "react";
import { Card, Table, Button, Spinner } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import NotificationFormModal from "./NotificationFormModal";

const AdminNotificationsComp = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const fetchNotifications = async () => {
    try {
      const { data } = await api.get("/notifications/admin");
      setItems(data.data ?? data.items ?? []);
    } catch {
      toast.error("خطا در دریافت نوتیفیکیشن‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const deleteNotification = async (id) => {
    if (!window.confirm("آیا از حذف اعلان مطمئن هستید؟")) return;
    try {
      await api.delete(`/notifications/${id}`);
      toast.success("اعلان حذف شد");
      fetchNotifications();
    } catch {
      toast.error("خطا در حذف اعلان");
    }
  };

  const disableNotification = async (id) => {
    try {
      await api.patch(`/notifications/${id}/disable`);
      toast.success("اعلان غیرفعال شد");
      fetchNotifications();
    } catch {
      toast.error("خطا در غیرفعال‌سازی اعلان");
    }
  };

  if (loading)
    return <Spinner animation="border" className="d-block m-auto mt-5" />;

  return (
    <>
      <div className="mb-3">
        <Button
          onClick={() => {
            setEditItem(null);
            setShowForm(true);
          }}
        >
          افزودن اعلان جدید
        </Button>
      </div>

      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <div className="table-responsive">
            <Table className="align-middle">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>تاریخ</th>
                  <th>کاربر</th>
                  <th>کانال</th>
                  <th>عنوان</th>
                  <th>وضعیت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {items.map((n) => (
                  <tr key={n.id}>
                    <td>#{n.id}</td>
                    <td>{new Date(n.createdAt).toLocaleString("fa-IR")}</td>
                    <td>{n.user?.name} {n.user?.family} ({n.user?.code})</td>
                    <td>{n.channels?.[0]?.channel}</td>
                    <td>{n.title}</td>
                    <td>
                      <span
                        className={`badge bg-opacity-10 p-2 fs-12 fw-medium ${
                          n.channels?.[0]?.status === "READ"
                            ? "text-success"
                            : "text-warning"
                        }`}
                      >
                        {n.channels?.[0]?.status}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="border-0 bg-transparent"
                          onClick={() => {
                            setEditItem(n);
                            setShowForm(true);
                          }}
                        >
                          <span className="material-symbols-outlined text-warning">
                            edit
                          </span>
                        </button>

                        <button
                          className="border-0 bg-transparent"
                          onClick={() => disableNotification(n.id)}
                        >
                          <span className="material-symbols-outlined text-secondary">
                            block
                          </span>
                        </button>

                        <button
                          className="border-0 bg-transparent"
                          onClick={() => deleteNotification(n.id)}
                        >
                          <span className="material-symbols-outlined text-danger">
                            delete
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <NotificationFormModal
        show={showForm}
        onHide={() => setShowForm(false)}
        notification={editItem}
        onSuccess={fetchNotifications}
      />
    </>
  );
};

export default AdminNotificationsComp;
